import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import Navbar from "../../../Navbar/Navbar";
import _ from "lodash";
import Time from "react-time-format";
const PriceUpdate = () => {
    return (
        <>
            <ProductConsumer>
                {(value) => {
                    const {
                        P_nrxDinar,
                        P_nrxkamtrlaniw,
                        P_nrxkamptrlada,
                        P_mufrad_,
                        AddProChange,
                        P_productUpdatePrice,
                        P_nrxDolar,
                        P_nrxDolar2,
                        P_data,
                    } = value;

                    return (
                        <>
                            <Navbar />
                            <br />
                            <br />
                            <br />
                            <div className="row " style={{ backgroundColor: "#2C3539" }}>
                                {/* Form take moneyy */}
                                <div className="col-lg-12  text-black col-12 " >
                                    <div
                                        className="card card-warning "
                                        style={{ backgroundColor: "#dadad0" }}
                                    >
                                        <div
                                            className="card-header p-1 border-bottom border-warning"
                                            style={{ backgroundColor: "#dadad0" }}
                                        >
                                            <h2 className="card-title tc">
                                                بەشی گۆڕانکاری نرخ
                                            </h2>
                                        </div>

                                        <div className="card-body">
                                            <form>
                                                <div className="row">
                                                    <div className="col-lg-3 col-md-6 col-sm-6 text-right">
                                                        <div className="form-group">
                                                            <label className="font-weight-bold  ">
                                                                نرخی مفرد
                                                            </label>
                                                            <NumberFormat
                                                                value={P_mufrad_}
                                                                name="P_mufrad_"
                                                                onChange={AddProChange}
                                                                displayType="input"
                                                                className="form-control   text-right font-weight-bold p-2"
                                                                thousandSeparator={true}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3 col-md-6 col-sm-6 text-right">
                                                        <div className="form-group">

                                                            <label className="font-weight-bold  ">
                                                                نرخی کەمتر لە دە دەرزەن
                                                            </label>
                                                            <NumberFormat
                                                                value={P_nrxkamptrlada}
                                                                name="P_nrxkamptrlada"
                                                                onChange={AddProChange}
                                                                displayType="input"
                                                                className="form-control   text-right font-weight-bold p-2"
                                                                thousandSeparator={true}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3 col-md-6 col-sm-6 text-right">
                                                        <div className="form-group">
                                                            <label className="font-weight-bold  ">
                                                                نرخی کەمتر لە نیو کارتۆن
                                                            </label>
                                                            <NumberFormat
                                                                value={P_nrxkamtrlaniw}
                                                                name="P_nrxkamtrlaniw"
                                                                onChange={AddProChange}
                                                                displayType="input"
                                                                className="form-control   text-right font-weight-bold p-2"
                                                                thousandSeparator={true}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3 col-md-6 col-sm-6 text-right">
                                                        <div className="form-group">
                                                            <label className="font-weight-bold  ">
                                                                نرخی فرؤشتن دینار
                                                            </label>
                                                            <NumberFormat
                                                                value={P_nrxDinar}
                                                                name="P_nrxDinar"
                                                                onChange={AddProChange}
                                                                displayType="input"
                                                                className="form-control   text-right font-weight-bold p-2"
                                                                thousandSeparator={true}

                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3 col-md-6 col-sm-6 text-right"></div>
                                                    <div className="col-lg-3 col-md-6 col-sm-6 text-right"></div>
                                                    <div className="col-lg-3 col-md-6 col-sm-6 text-right">
                                                        <div className="form-group">
                                                            <label className="font-weight-bold  ">
                                                                نرخی فرؤشتن دۆلار2
                                                            </label>
                                                            <NumberFormat
                                                                value={P_nrxDolar}
                                                                name="P_nrxDolar"
                                                                onChange={AddProChange}
                                                                displayType="input"
                                                                className="form-control   text-right font-weight-bold p-2"
                                                                thousandSeparator={true}

                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-3 col-md-6 col-sm-6 text-right">
                                                        <div className="form-group">
                                                            <label className="font-weight-bold  ">
                                                                نرخی فرؤشتن دۆلار1
                                                            </label>
                                                            <NumberFormat
                                                                value={P_nrxDolar2}
                                                                name="P_nrxDolar2"
                                                                onChange={AddProChange}
                                                                displayType="input"
                                                                className="form-control   text-right font-weight-bold p-2"
                                                                thousandSeparator={true}

                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            <div className="row">
                                                <div className="col-6"></div>
                                                <div className="col-2">
                                                    <button className="btn btn-lg btn-warning" onClick={P_productUpdatePrice}>
                                                        <i className="fas fa-edit fa-lg"></i>
                                                    </button>
                                                </div>
                                                <div className="col-4"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <table
                                    id="example"
                                    className="table table-hover table-bordered text-right "
                                >
                                    <thead>
                                        <tr
                                            className="text-warning f4"
                                            style={{ backgroundColor: "#2C3539" }}
                                        >
                                            <th style={{ border: "2px solid #f0ad4e" }}>نرخی مفرد</th>
                                            <th style={{ border: "2px solid #f0ad4e" }}>نرخی کەمتر لە دە</th>
                                            <th style={{ border: "2px solid #f0ad4e" }}>نرخی کەمتر لە نیوە </th>
                                            <th style={{ border: "2px solid #f0ad4e" }}>نرخی فرۆشتن دینار</th>
                                            <th style={{ border: "2px solid #f0ad4e" }}>نرخی فرۆشتن دۆلار2</th>
                                            <th style={{ border: "2px solid #f0ad4e" }}>نرخی فرؤشتن دۆلار1</th>
                                            <th style={{ border: "2px solid #f0ad4e" }}>
                                                بەروار
                                            </th>
                                            <th style={{ border: "2px solid #f0ad4e" }}>ژ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {P_data.map(el => {
                                            return <tr>
                                                <td>{el.singleSale}</td>
                                                <td>{el.saleOfLessTenDarzan}</td>
                                                <td>{el.saleOfLessHalfCarton}</td>
                                                <td>{el.saleDinar}</td>
                                                <td>{el.nrxeFroshtnDolar2}</td>
                                                <td>{el.saleDolar}</td>
                                                <td><Time
                                                    value={el.createdAt}
                                                    format="YYYY-MM-DD"
                                                    style={{ color: "black" }}
                                                /></td>
                                                <td>{el.numberofwasl}</td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    );
                }}
            </ProductConsumer>
        </>
    );
};
export default PriceUpdate;
